import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import heroVideo from "../assets/HeroVid.mp4";
import "./HomePage.css";
import funeralFlyer from "../assets/JERRY MADITHAPA FUNERALS FLYER A5 BACK_053837.pdf";
import emailjs from "@emailjs/browser";
import toast from "react-hot-toast";

// Gallery images
import img1 from "../assets/2 cars.jpeg";
import img2 from "../assets/flowers.jpeg";
import img3 from "../assets/2 cars side.jpeg";
import img4 from "../assets/serving.jpeg";
import img5 from "../assets/table.jpeg";
import img6 from "../assets/tent.jpeg";
import img7 from "../assets/tent&flowers.jpeg";
import img8 from "../assets/water.jpeg";
import img9 from "../assets/tent&flowers 2.jpeg";
import img10 from "../assets/tent 3.jpeg";

export default function HomePage() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const section = document.querySelector(location.hash);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const packages = [
    { id: 1, name: "STANDARD PLAN", price: "R280.00" },
    { id: 2, name: "CASKET PLAN", price: "R880.00" },
    { id: 3, name: "MINI DOME PLAN", price: "R1,200.00" },
  ];

  const slides = [
    { src: img1, alt: "Funeral Cars" },
    { src: img2, alt: "Flower Arrangement" },
    { src: img3, alt: "Side View Cars" },
    { src: img4, alt: "Serving Setup" },
    { src: img5, alt: "Table Setup" },
    { src: img6, alt: "Tent Setup" },
    { src: img7, alt: "Tent and Flowers" },
    { src: img8, alt: "Water Setup" },
    { src: img9, alt: "Tent and Flowers 2" },
    { src: img10, alt: "Tent Setup 3" },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const goToSlide = (index) => setCurrentIndex(index);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    message: "",
  });

  const validateForm = () => {
    let errors = {};

    if (!formData.name.trim()) {
      errors.name = "Full name is required";
    } else if (formData.name.trim().length < 3) {
      errors.name = "Name must be at least 3 characters";
    }

    const phoneRegex = /^(?:\+27|0)[6-8][0-9]{8}$/;
    if (!formData.phone.trim()) {
      errors.phone = "Phone number is required";
    } else if (!phoneRegex.test(formData.phone)) {
      errors.phone =
        "Enter a valid SA number (e.g. 0821234567 or +27821234567)";
    }

    if (!formData.message.trim()) {
      errors.message = "Message is required";
    } else if (formData.message.trim().length < 10) {
      errors.message = "Message must be at least 10 characters";
    }

    if (Object.keys(errors).length > 0) {
      toast.error("Please fix the errors in the form");
      return false;
    }

    return true;
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const loadingToast = toast.loading("Sending message...");

    try {
      await emailjs.send(
        "service_gdiwjdn",
        "template_s9ohgpb",
        {
          from_name: formData.name,
          phone: formData.phone,
          message: formData.message,
          time: new Date().toLocaleString(),
        },
        "864iSg_WGVJch7qmg"
      );

      toast.success("Message sent successfully!", { id: loadingToast });

      setFormData({
        name: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      console.error(error);
      toast.error("Failed to send message. Please try again.", {
        id: loadingToast,
      });
    }
  };

  return (
    <div>
      {/* HERO */}
      <section className="hero" id="home">
        <video
          className="hero-video"
          src={heroVideo}
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="hero-overlay"></div>

        <div className="hero-content">
          <h1>
            <span className="highlight">JERRY</span> MADITHAPA FUNERALS
          </h1>
          <p>
            Peace Of Mind, <span className="highlight">Dignified Goodbye</span>
          </p>
          <button onClick={() => (window.location.href = "#packages")}>
            View Packages
          </button>
        </div>
      </section>

      {/* ABOUT */}
      <section className="section" id="about">
        <h2>About Us</h2>
        <p>
          Jerry Madithapa Funerals (JM Funerals) is a family based business,
          owned by people who understand the pain and grief that comes with
          losing a loved one.
        </p>
      </section>

      {/* PACKAGES */}
      <section className="section dark" id="packages">
        <h2>Funeral Packages</h2>

        <div className="packages-container">
          {packages.map((pkg) => (
            <div
              key={pkg.id}
              className="package-card"
              onClick={() => navigate(`/packages/${pkg.id}`)}
            >
              <h3>{pkg.name}</h3>
              <p className="fee">Joining Fee</p>
              <p className="price">{pkg.price}</p>
              <button>View Package</button>
            </div>
          ))}
        </div>

        <div className="pdf-buttons">
          <a href={funeralFlyer} download className="pdf-btn">
            Download Funeral Flyer
          </a>
        </div>
      </section>

      {/* GALLERY */}
      <section className="section gallery" id="gallery">
        <h2>Gallery</h2>
        <div className="container">

          {slides.map((slide, index) => (
            <div
              key={index}
              className="mySlides"
              style={{ display: index === currentIndex ? "block" : "none" }}
            >
              <div className="numbertext">
                {index + 1} / {slides.length}
              </div>
              <img src={slide.src} alt={slide.alt} style={{ width: "100%" }} />
            </div>
          ))}

          <div className="row">
            {slides.map((slide, index) => (
              <div key={index} className="column">
                <img
                  className={`demo cursor ${
                    index === currentIndex ? "active" : ""
                  }`}
                  src={slide.src}
                  alt={slide.alt}
                  style={{ width: "100%" }}
                  onClick={() => goToSlide(index)}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section className="section" id="contact">
        <h2>Contact Us</h2>
        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
          />

          <textarea
            name="message"
            placeholder="Message"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>

          <button type="submit">Send Message</button>
        </form>
      </section>
    </div>
  );
}